itsoftApp.createModule("cookie", function () {
    var module = this;
    var DEFAULT_DATE = 900; //24 ч || // 900 - 15 мин ???

    var setCookie = function (element, date, cookieValue) {
        var dAttrSave = element.getAttribute("data-save");

        if (!date) {
            // var date = DEFAULT_DATE;
            // document.cookie = dAttrSave +"=yes; path=/; max-age=" + date;
            document.cookie = dAttrSave +"=yes; path=/";
        } else if (cookieValue) {
            document.cookie = dAttrSave + cookieValue + "; path=/; max-age=" + date;
        } else {
            document.cookie = dAttrSave +"=yes; path=/; max-age=" + date;
        }
    };

    var getCookie = function (element) {
        var dAttrSave = element.getAttribute("data-save");
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    var deleteCookie = function (element) {
        setCookie(element, {
            "max-age": -1
        }, "");
    };

    module.setCookie = setCookie;
    module.getCookie = getCookie;
    module.deleteCookie = deleteCookie;
});